import {
  createTiming,
  establishesOutcome,
  IDEMPOTENCY_TTL_MS,
  OutcomeUnknownError,
  postIdempotent,
  REQUEST_ID_REUSE_MS,
  unconfirmedStore,
  UnconfirmedCreate,
} from 'config/idempotentCreate';

/**
 * EV-128（ADM-14 の AC1）。配送先の作成（POST /v1/client_deliveries/）を、結果が分からない
 * 失敗の後も二重に作らずに取り直せるようにする。
 *
 * 仕組みは作業マスタ・機器・車両の作成（EV-129〜131）と共通にし、config/idempotentCreate.ts に
 * 移した。ここは配送先の作成の入口と、これまでの名前（loadUnconfirmed など）を残す。
 */

export {
  createTiming,
  establishesOutcome,
  IDEMPOTENCY_TTL_MS,
  OutcomeUnknownError,
  REQUEST_ID_REUSE_MS,
};
export type { UnconfirmedCreate };

export const CLIENT_DELIVERIES_URL = '/v1/client_deliveries/';

const store = unconfirmedStore('client');

/** RV-130。配送先の作成で結果が分からなかった値（利用者の印が違えば null）。 */
export const loadUnconfirmed = store.load;
/** 値を残す（EV-138。onlyOwn なら自分の作成の値のときだけ書く）。 */
export const saveUnconfirmed = store.save;
/** 値を消す（EV-138・RV-131。requestId と本文を渡せば、自分の作成の値のときだけ消す）。 */
export const clearUnconfirmed = store.clear;

export function createClient(payload: { [key: string]: any }, requestId: string): Promise<any> {
  return postIdempotent(CLIENT_DELIVERIES_URL, payload, requestId);
}
